import { Message, TotaalFacturenInterface } from '@app/core/interfaces';
import { VaststellingFactuurInterface } from '@app/core/interfaces/vaststelling-factuur.interface';
import { type } from '@app/store/util';
import { Action } from '@ngrx/store';

/** @deprecated moved to libs folder */
export const LOAD_INVOICES = type('[Invoice] Load Invoices');
/** @deprecated moved to libs folder */
export const LOAD_INVOICES_SUCCESS = type('[Invoice] Load Invoices Success');
/** @deprecated moved to libs folder */
export const LOAD_INVOICE_DETAIL = type('[Invoice] Load Invoice Detail');
/** @deprecated moved to libs folder */
export const LOAD_INVOICE_DETAIL_SUCCESS = type('[Invoice] Load Invoice Detail Success');
/** @deprecated moved to libs folder */
export const SET_SELECTED_ID = type('[Invoice] Set Selected Id');
/** @deprecated moved to libs folder */
export const SET_PAYMENT = type('[Invoice] Set Payment');
/** @deprecated moved to libs folder */
export const SET_PAYMENT_SUCCESS = type('[Invoice] Set Payment Success');
/** @deprecated moved to libs folder */
export const SET_SELECTED_YEAR = type('[Invoice] Set Selected Year');
/** @deprecated moved to libs folder */
export const SET_ERROR = type('[Invoice] Set Error');
/** @deprecated moved to libs folder */
export const CLEAR_ERROR = type('[Invoice] Reset Error');
/** @deprecated moved to libs folder */
export const LOADING_DONE = type('[Invoice] Loading Done');

/** @deprecated moved to libs folder */
export class LoadInvoices implements Action {
    readonly type = LOAD_INVOICES;
    constructor(public payload: { jaartal: number }) { }
}

/** @deprecated moved to libs folder */
export class LoadInvoicesSuccess implements Action {
    readonly type = LOAD_INVOICES_SUCCESS;
    constructor(public payload: { totaal_factuur: TotaalFacturenInterface }) { }
}

/** @deprecated moved to libs folder */
export class LoadInvoiceDetail implements Action {
    readonly type = LOAD_INVOICE_DETAIL;
    constructor(public payload: { factuur_id: string }) { }
}

/** @deprecated moved to libs folder */
export class LoadInvoiceDetailSuccess implements Action {
    readonly type = LOAD_INVOICE_DETAIL_SUCCESS;
    constructor(public payload: { detail_factuur: VaststellingFactuurInterface }) { }
}

/** @deprecated moved to libs folder */
export class SetSelectedId implements Action {
    readonly type = SET_SELECTED_ID;
    constructor(public payload: { factuur_id: string }) { }
}

/** @deprecated moved to libs folder */
export class SetSelectedYear implements Action {
    readonly type = SET_SELECTED_YEAR;
    constructor(public payload: { jaartal: number }) { }
}

/** @deprecated moved to libs folder */
export class SetPayment implements Action {
    readonly type = SET_PAYMENT;
    constructor(public payload: { invoice_id: string, bank_id: string }) { }
}

/** @deprecated moved to libs folder */
export class SetPaymentSuccess implements Action {
    readonly type = SET_PAYMENT_SUCCESS;
    constructor(public payload: { url: string }) { }
}

/** @deprecated moved to libs folder */
export class SetError implements Action {
    readonly type = SET_ERROR;
    constructor(public payload: { errors: Message[] }) { }
}

/** @deprecated moved to libs folder */
export class ClearError implements Action {
    readonly type = CLEAR_ERROR;
    constructor() { }
}

/** @deprecated moved to libs folder */
export class LoadingDone implements Action {
    readonly type = LOADING_DONE;
    constructor() { }
}

/** @deprecated moved to libs folder */
export type InvoicesActions
    = LoadInvoices
    | LoadInvoicesSuccess
    | LoadInvoiceDetail
    | LoadInvoiceDetailSuccess
    | SetSelectedId
    | SetSelectedYear
    | SetPayment
    | SetPaymentSuccess
    | SetError
    | ClearError
    | LoadingDone;
